import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ValueBox from  '../common/widget/valueBox'
import Row from  '../common/layout/row'
import InfoBox from  '../common/infoBox/infoBox'
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Button from '../common/button/button';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import ReactExport from 'react-export-excel-fixed-xlsx';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import imagemCapa from '../assets/images/foto_dashboard.jpg';
import Select from 'react-select';

import { 
	getLista, getListaMetaVisita
} from './dashboardActions';

import contentCardBody from '../common/template/contentCardBody';

class Dashboard extends Component {

	state = {
		ano: new Date().getFullYear(),
		janeiro: false,
		fevereiro: false,
		marco: false,
		abril: false,
		maio: false,
		junho: false,
		julho: false,
		agosto: false,
		setembro: false,
		outubro: false,
		novembro: false,
		dezembro: false
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.listar(this.state);
    }

	listar(state) {
		this.setState({
			...state
		});

		let ano = state.ano || new Date().getFullYear();
		let competencias = [];
		
		let todos = 
			!state.janeiro
			&& !state.fevereiro
			&& !state.marco
			&& !state.abril
			&& !state.maio
			&& !state.junho
			&& !state.julho
			&& !state.agosto
			&& !state.setembro
			&& !state.outubro
			&& !state.novembro
			&& !state.dezembro;

		if (state.janeiro || todos) {
			competencias.push(`${ano}01`);
		}
		if (state.fevereiro || todos) {
			competencias.push(`${ano}02`);
		}
		if (state.marco || todos) {
			competencias.push(`${ano}03`);
		}
		if (state.abril || todos) {
			competencias.push(`${ano}04`);
		}
		if (state.maio || todos) {
			competencias.push(`${ano}05`);
		}
		if (state.junho || todos) {
			competencias.push(`${ano}06`);
		}
		if (state.julho || todos) {
			competencias.push(`${ano}07`);
		}
		if (state.agosto || todos) {
			competencias.push(`${ano}08`);
		}
		if (state.setembro || todos) {
			competencias.push(`${ano}09`);
		}
		if (state.outubro || todos) {
			competencias.push(`${ano}10`);
		}
		if (state.novembro || todos) {
			competencias.push(`${ano}11`);
		}
		if (state.dezembro || todos) {
			competencias.push(`${ano}12`);
		}

		this.setState({
			...state,
			competencias: competencias
		});

		this.props.getLista({ ano: ano, competencias: competencias.map(comp => parseInt(comp)) });

		this.props.getListaMetaVisita();
	}

    render() {

		const listaMetaVisita = this.props.listaMetaVisita.filter(item => {
			return (this.state.competencias || []).filter(comp => comp == item.competencia).length;
		});

		let totalChecklistPorRegiao = 0;
		(this.props.indicadores.checklistsPorRegiao || []).forEach(item => {
			totalChecklistPorRegiao += parseInt(item.quantidade || 0);
		});

		let totalVisitasPorRegiao = 0;
		(this.props.indicadores.visitasPorRegiao || []).forEach(item => {
			totalVisitasPorRegiao += parseInt(item.quantidade || 0);
		});

		let metaVisitaTotal = 0;
		listaMetaVisita.forEach(meta => {
			metaVisitaTotal += parseInt(meta.quantidade || 0);
		});

		let totalPessoasTreinadasPorRegiao = 0;
		(this.props.indicadores.pessoasTreinadasRegiao || []).forEach(item => {
			totalPessoasTreinadasPorRegiao += parseInt(item.quantidade || 0);
		});

        return (
			<section className='content'
				style={{
					backgroundImage: `url(${imagemCapa})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					// height: '100vh',
					width: '100%'
				}}>

				<Aguardando aguardando={this.props.aguardando} />

				<div style={{ padding: 8 }}>
					<Row alignCenter>
						<Select
							styles={{ 
								container: (provided) => ({
									...provided,
									width: 105,
									padding: 0,
									marginTop: 0,
									marginBottom: 2
								})
							}}
							defaultValue={{ value: this.state.ano, label: this.state.ano }}
							isClearable={false}
							isSearchable={true}
							onChange={(item) => this.listar({ ...this.state, ano: item.value })}
							options={[{ value: 2024, label: 2024 }, { value: 2025, label: 2025 }, { value: 2026, label: 2026 },{ value: 2027, label: 2027 }]} />
						
						<button type='button' 
							class={`btn btn-block btn-${this.state.janeiro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, janeiro: !this.state.janeiro })}>
							Janeiro
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.fevereiro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, fevereiro: !this.state.fevereiro })}>
							Fevereiro
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.marco ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, marco: !this.state.marco })}>
							Março
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.abril ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, abril: !this.state.abril })}>
							Abril
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.maio ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, maio: !this.state.maio })}>
							Maio
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.junho ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, junho: !this.state.junho })}>
							Junho
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.julho ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, julho: !this.state.julho })}>
							Julho
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.agosto ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, agosto: !this.state.agosto })}>
							Agosto
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.setembro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, setembro: !this.state.setembro })}>
							Setembro
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.outubro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, outubro: !this.state.outubro })}>
							Outubro
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.novembro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, novembro: !this.state.novembro })}>
							Novembro
						</button>
						<button type='button' 
							class={`btn btn-block btn-${this.state.dezembro ? 'dark' : 'light'} btn-flat`}
							style={{ width: 100, height: 38, padding: 0, marginTop: 0, marginBottom: 2 }}
							onClick={() => this.listar({ ...this.state, dezembro: !this.state.dezembro })}>
							Dezembro
						</button>			
					</Row>
				</div>
				
				<div style={{ padding: 8, marginTop: 16 }}>
					<Row>
						{this.montarCard('Checklists Agendados', this.props.indicadores.agendados || 0, 'fas fa-calendar-check')}
						{this.montarCard('Checklists em Andamento', this.props.indicadores.andamento || 0, 'fas fa-play')}
						{this.montarCard('Checklists em Análise', this.props.indicadores.analise || 0, 'fas fa-clipboard-check')}
						{this.montarCard('Checklists Finalizados', this.props.indicadores.finalizados || 0, 'fas fa-check-double')}
						{this.montarCard('Visitas Realizadas', this.props.indicadores.visitas || 0, 'fas fa-handshake')}
						{this.montarCard('Clientes Visitados no Ano', this.props.indicadores.clientesVisitados || 0, 'fas fa-user-check')}
						{this.montarCard('Treinamentos Realizados', this.props.indicadores.treinamentos || 0, 'fas fa-user-check')}
						{this.montarCard('Pessoas Treinadas', this.props.indicadores.pessoasTreinadas || 0, 'fas fa-user-check')}

						{this.montarCard('Certificados de Checklists', this.props.indicadores.certificadoChecklist || 0, 'fas fa-certificate')}
						{this.montarCard('Certificados KeplerFlix', this.props.indicadores.certificadoKeplerFlix || 0, 'fas fa-certificate')}
						{this.montarCard('Certificados Avulsos', this.props.indicadores.certificadoAvulso || 0, 'fas fa-certificate')}
						{this.montarCard('Certificados - Todos', 
							this.props.indicadores.certificadoChecklist
							+ this.props.indicadores.certificadoKeplerFlix
							+ this.props.indicadores.certificadoAvulso, 
							'fas fa-certificate'
						)}
					</Row>
				
					<Row>
						<div class="col-12 col-sm-6 col-md-6" style={{ opacity: 0.8 }}>
							<div class="info-box">
								<div class="info-box-content">
									<p class="text-center" style={{ textAlign: 'center', color: '#231f20', paddingTop: 16, paddingBottom: 16 }}>
										<strong>Checklists Realizados por Região</strong>
									</p>
									{(this.props.indicadores.checklistsPorRegiao || []).map(item => {
										return (
											<div key={item.nome_grupo} class="progress-group">
												<b>{item.nome_grupo}</b>
												<span class="float-right"><b>{item.quantidade}</b></span>
												<div class="progress progress-sm" style={{ height: 10 }}>
													<div class="progress-bar btn-warning" style={{ width: `${totalChecklistPorRegiao > 0 ? (parseInt(item.quantidade || 0) * 100) / totalChecklistPorRegiao : 0}%` }}></div>
												</div>
											</div>
										);
									})}
									<div class="progress-group">
										<b>Total</b>
										<span class="float-right"><b>{totalChecklistPorRegiao}</b></span>
										<div class="progress progress-sm" style={{ height: 10 }}>
											<div class="progress-bar btn-warning" style={{ width: `100%` }}></div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="col-12 col-sm-6 col-md-6" style={{ opacity: 0.8 }}>
							<div class="info-box">
								<div class="info-box-content">
									<p class="text-center" style={{ textAlign: 'center', color: '#231f20', paddingTop: 16, paddingBottom: 16 }}>
										<strong>Visitas Realizadas por Região</strong>
									</p>
									{(this.props.indicadores.visitasPorRegiao || []).map(item => {

										let metaVisita = 0;
										listaMetaVisita.filter(meta => meta.id_grupo_cliente == item.id_grupo).forEach(meta => {
											metaVisita += parseInt(meta.quantidade || 0);
										});

										return (
											<div key={item.nome_grupo} class="progress-group">
												<b>{item.nome_grupo}</b>
												<span class="float-right"><b>{item.quantidade} de {metaVisita}</b></span>
												<div class="progress progress-sm" style={{ height: 10 }}>
													<div class="progress-bar btn-warning" style={{ width: `${metaVisita > 0 ? (parseInt(item.quantidade || 0) * 100) / metaVisita : 100}%` }}></div>
												</div>
											</div>
										);
									})}
									<div class="progress-group">
										<b>Total</b>
										<span class="float-right"><b>{totalVisitasPorRegiao} de {metaVisitaTotal}</b></span>
										<div class="progress progress-sm" style={{ height: 10 }}>
											<div class="progress-bar btn-warning" style={{ width: `${metaVisitaTotal > 0 ? (totalVisitasPorRegiao * 100) / metaVisitaTotal : 100}%` }}></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Row>

					<Row>
						<div class="col-12 col-sm-6 col-md-6" style={{ opacity: 0.8 }}>
							<div class="info-box">
								<div class="info-box-content" style={{ textAlign: 'center', alignItems: 'center' }}>
									<p class="text-center" style={{ textAlign: 'center', color: '#231f20', paddingTop: 16, paddingBottom: 16 }}>
										<strong>Meta de Visitas</strong>

										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.props.sessao.id_perfil == 1 || this.props.sessao.id_perfil == 7} /*Adm*/
											event={() => {
												window.location = '/#/metaVisita';
											}} />
									</p>
									<img style={{ width: '80%', textAlign: 'center', marginBottom: 16 }} 
										src={`
										https://quickchart.io/chart?height=300&width=1000&c={
											type: 'gauge',
											data: {
												datasets: [{
													value: ${metaVisitaTotal > 0 ? ((this.props.indicadores.visitas || 0) * 100) / metaVisitaTotal : 0},
													data: [33, 67, 100],
													backgroundColor: ['rgb(255, 0, 0)', 'rgb(255, 215, 0)', 'rgb(50, 205, 50)'],
													borderWidth: 2
												}]
											},
											options: {
												valueLabel: {
													fontSize: 8,
													backgroundColor: 'transparent',
													color: 'rgb(0, 0, 0)',
													bottomMarginPercentage: -10
												}
											}
										}`} />
									<p style={{ color: '#231f20', fontWeight: 'bold', marginTop: 9, marginBottom: 24 }}>{this.props.indicadores.visitas || 0} de {metaVisitaTotal}</p>
								</div>
							</div>
						</div>

						<div class="col-12 col-sm-6 col-md-6" style={{ opacity: 0.8 }}>
							<div class="info-box">
								<div class="info-box-content">
									<p class="text-center" style={{ textAlign: 'center', color: '#231f20', paddingTop: 16, paddingBottom: 16 }}>
										<strong>Pessoas Treinadas por Região</strong>
									</p>
									{(this.props.indicadores.pessoasTreinadasRegiao || []).map(item => {

										return (
											<div key={item.nome_grupo} class="progress-group">
												<b>{item.nome_grupo}</b>
												<span class="float-right"><b>{item.quantidade}</b></span>
												<div class="progress progress-sm" style={{ height: 10 }}>
													<div class="progress-bar btn-warning" style={{ width: `${parseInt(this.props.indicadores.pessoasTreinadas || 0) > 0 ? (parseInt(item.quantidade || 0) * 100) / parseInt(this.props.indicadores.pessoasTreinadas) : 100}%` }}></div>
												</div>
											</div>
										);
									})}
									<div class="progress-group">
										<b>Total</b>
										<span class="float-right"><b>{totalPessoasTreinadasPorRegiao}</b></span>
										<div class="progress progress-sm" style={{ height: 10 }}>
											<div class="progress-bar btn-warning" style={{ width: `100%` }}></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Row>
				</div>
				
			</section>
        )
	}

	montarCard(nome, quantidade, icone) {

		return (
			<div class="col-12 col-sm-6 col-md-3" style={{ opacity: 0.8 }}>
				<div class="info-box">
					<span class="info-box-icon btn-warning elevation-1"><i class={icone}></i></span>
					<div class="info-box-content" style={{ textAlign: 'center', color: '#231f20', paddingTop: 16, paddingBottom: 16 }}>
						<span class="info-box-text" style={{ fontWeight: 'bold' }}>{nome}</span>
						<span class="info-box-number" style={{ fontSize: 28, fontWeight: 'bold', marginTop: 26 }}>{quantidade}</span>
					</div>
				</div>
			</div>
		);
	}

	setDialogItens(itens) {
		this.setState({
			...this.state,
			itens: itens
		})
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboard.aguardando,
	indicadores: state.dashboard.indicadores,
	listaMetaVisita: state.dashboard.listaMetaVisita
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista, getListaMetaVisita
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
